module.exports = __webpack_public_path__ + "img/sentinel.abdf293e.png";